
import React from 'react'
import Page from '../components/Page'

export default class extends React.Component {
  render() {
    return (
      <Page title="Upgrade items" padding>
        <h3>Upgrade items</h3>
        <p>1 Ral Rune + 1 Sol Rune + 1 Perfect Emerald + Normal Unique Weapon --> Exceptional Version of Weapon</p>
        <p>1 Tal Rune + 1 Shael Rune + 1 Perfect Diamond + Normal Unique Armor --> Exceptional Version of Armor</p>
        <p>1 Lum Rune + 1 Pul Rune + 1 Perfect Emerald + Exceptional Unique Weapon --> Elite Version of Weapon</p>
        <p>1 Ko Rune + 1 Lem Rune + 1 Perfect Diamond + Exceptional Unique Armor --> Elite Version of Armor</p>
        <p>1 Ort Rune + 1 Amn Rune + 1 Perfect Sapphire + Normal (Basic) Rare Weapon --> Exceptional Rare Weapon</p>
        <p>1 Ral Rune + 1 Thul Rune + 1 Perfect Amethyst + Normal (Basic) Rare Armor --> Exceptional Rare Armor</p>
        <p>1 Fal Rune + 1 Um Rune + 1 Perfect Sapphire + Exceptional Rare Weapon --> Elite Rare Weapon</p>
        <p>1 Ko Rune + 1 Pul Rune + 1 Perfect Amethyst + Exceptional Rare Armor --> Elite Rare Armor</p>

      </Page>
    )
  }
}